import React, { Component } from 'react';
import withStyles from 'react-jss'
import {withContext} from './StateProvider';
import Drawer from '@material-ui/core/Drawer';

const styles = theme => ({
    overlay:{
        position:'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        backgroundColor:'rgba(0,0,0,0.6)',
        zIndex:1000,
    },
    drawer:{
        position:'absolute',
        border:'1px solid black',
        borderRadius:10,
        padding:10,
        backgroundColor: 'white',
        zIndex:1001,
        top:'50%',
        left:'50%'
    },
    closeButton:{
        float:'right',
        zIndex:1010,
    }
});

class ContentDrawer extends Component {
    state={
        wallet:[]
    };
    
    render() {

        return (

        <Drawer anchor="right" open={this.props.drawerContent} onClose={this.onClose}>

            <div
              tabIndex={0}
              role="button"
              style={{width:this.props.drawerWidth || '300px', padding:0}}
            >
                {this.props.drawerContent}
            </div>
        </Drawer>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(ContentDrawer));


// WEBPACK FOOTER //
// ./src/yeffect/drawerWrapper.js